<template>
  <div class="footer_page">
    <div class="w1200 mar_auto">
      <div class="flex_box">
        <img src="../assets/images/logo_2.png" class="logo_size" alt="" />
        <div class="item ov">
          <div class="">CHINA BEAUTY EXPO - HANGZHOU</div>
          <div class="mt2">SHOW DATES: AUGUST 20-21, 2025</div>
          <div class="mt2">VENUE ADDRESS: HANGZHOU INTERNATIONAL EXPO CENTER (No.353, BENJING AVENUE, YINGFENG STREET, XIAOSHAN DISTRICT, HANGZHOU, CHINA)</div>

          <div class="mt12">CHINA BEAUTY EXPO - SHANGHAI</div>
          <div class="mt2">SHOW DATES: MAY 22-24, 2026</div>
          <div class="mt2">VENUE ADDRESS: SHANGHAI NEW INTERNATIONAL EXPO CENTER (No.2345, LONGYANG ROAD, PUDONG NEW AREA, SHANGHAI, CHINA)</div>
        </div>
        <div class="w320">
          <div class="">FOR QUESTIONS, PLEASE CONTACT VICKY SHI</div>
          <div class="mt5 df aic"><img src="../assets/images/icon_call.png" class="icon_call" alt="" /><span>+86 (21) 23263688</span></div>
          <div class="mt5 df aic"><img src="../assets/images/icon_email.png" class="icon_email" alt="" /><span>Visitors@ChinaBeautyExpo.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {

    },
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="less">
  .footer_page {
    //position: fixed;
    //left: 0;
    //bottom: 0;
    position: relative;
    bottom: 0;
    width: 100%;
    height: 300px;
    padding-top: 32px;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    background: #A90000;
    z-index: 6;
    .logo_size {
      position: relative;
      width: 173px;
      height: 96px;
      margin-right: 120px;
    }
    .icon_call,.icon_email {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .mt2 {
    margin-top: 2px;
  }
  
  
</style>
